var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-wrap"},[_c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('h3',[_vm._v("Siden blev ikke fundet")]),_vm._v(" "),_c('router-link',{staticClass:"return-button",attrs:{"to":_vm.to}},[_vm._v("Klik her for at gå til forsiden")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56b3e579","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageNotFound404.vue
// module id = pP3I
// module chunks = 1